import React from 'react'
import styles from './GreyBoxContent.scss'

const GreyBoxContent = (props) => {
	
  	return (
		<div className={props.visible ? styles.isVisible : styles.isHidden}>
			{props.children}
		</div>
	)
}
export default GreyBoxContent



// WEBPACK FOOTER //
// ./src/components/atoms/GreyBoxContent/index.js